module.exports = __webpack_public_path__ + "static/media/loading.f38c7e0b.gif";